import { createContext } from 'react'
import { ApolloClient, NormalizedCacheObject } from '@apollo/client'

const GqlClient = createContext<ApolloClient<NormalizedCacheObject> | undefined>(undefined)

export default GqlClient
